import axios from "axios";
import moment from 'moment';

const global = {
    // 本地路径
    // baseURL:'http://localhost:9999/jier-admin-service/',
    baseURL:'https://admin.jierapp.com/jier-admin-service',

    //验证上传
    beforeAvatarUpload: function(file) {
        let _type = false;
        if(file.type === 'image/jpeg' || file.type === 'image/png'){
            _type = true;
        }
        let _size = file.size / 1024 / 1024 < 4;

        if(!_type) this.$message.error('上传头像图片只能是JPG/PNG格式');

        if(!_size) this.$message.error('上传头像图片大小不能超过4MB');
        return _type && _size;
    },
    //日期格式化
    dateFormatter: function(){
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    myFormatDate(dateStr) {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    myFormatDateTow(dateStr) {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${month}/${day}`;
    },
    extractPathFromUrl(url) {
        const pathStart = url.indexOf('company');
        if (pathStart != -1){
            const pathEnd = url.indexOf('?');

            if (pathStart !== -1 && pathEnd !== -1) {
                return url.substring(pathStart, pathEnd);
            }
        }
        return url;
    },
    msg:function(val){
        this.$notify.info({
            title: '提示',
            duration: 2000,
            message: val
        });
    },
    errorMsg:function(val){
        this.$notify.error({
            title: '提示',
            duration: 2000,
            message: val
        });
    },
    clearObjOne(obj){
        for(let key in obj){
            obj[key]=''
        }
    },
    clearObjOne0(obj){
        for(let key in obj){
            obj[key]=0
        }
    },
    showApprovalStatus(val){
        // 0:未提交 1:未审核 2:审核通过 3：审批退回 4:已关闭
        if (val == 4){
            return "已完结";
        }else if (val == 3){
            return "审批退回";
        } else if (val == 2){
            return "审核通过";
        } else{
            return "未审核";
        }
    },
    clearObj(obj) {
        Object.keys(obj).forEach(key => {
            if (typeof obj[key] === 'number') {
                // 对于数字，你可以选择是设置为 0 或 null
                obj[key] = 0; // 或者 obj[key] = null;
            } else if (typeof obj[key] === 'string') {
                obj[key] = ""; // 将字符串设置为空字符串
            } else if (obj[key] instanceof Date) {
                obj[key] = null; // 将日期设置为 null
            } else if (obj[key] === null) {
                // 如果原始值就是 null，保持不变或根据需要调整
                obj[key] = null;
            } else if (Array.isArray(obj[key])) {
                obj[key] = []; // 清空数组
            } else if (typeof obj[key] === 'object') {
                // 对于内嵌对象，递归调用
                clearValues(obj[key]);
            }
        });
    },
    getDate15DaysLater() {
        return moment().add(15, 'days').format('YYYY-MM-DD');
    },
    getFileType(extension) {
        // 定义图片和视频的扩展名列表
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp','JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'TIFF', 'WEBP'];
        const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv','MP4', 'AVI', 'MOV', 'WMV', 'FLV', 'MKV'];

        // 判断扩展名是否在图片列表中
        if (imageExtensions.includes(extension)) {
            return 'pic';
        }
        // 判断扩展名是否在视频列表中
        else if (videoExtensions.includes(extension)) {
            return 'video';
        }
        // 如果都不是，则返回 'other'
        else {
            return 'other';
        }
    },
    showNotificationsTitle(data){
        if (data.length > 10){
            return data.substring(0, 10) + '...';
        }
        return data;
    },
    // 将 订单中粘贴的数据放到对象中
    parseLogisticsData(dataString) {
        // 分割字符串以获取每一行
        const lines = dataString.split('\n');
        // 创建一个空对象来存储解析后的数据
        const dataObject = {};
        // 创建一个空对象来追踪每个键的出现次数
        const keyCount = {};

        // 遍历每一行
        lines.forEach(line => {
            // 分割每一行为键和值，这里使用全角冒号“：”作为分隔符
            let noSpaces = line.replace(/\s+/g, '');
            let [key, value] = noSpaces.split('：');
            if (typeof (key) === "undefined" || typeof (value) === "undefined") {
                 [key, value] = noSpaces.split(':');
            }
            if (typeof (key) === "undefined" || typeof (value) === "undefined") {
                console.info("== 解析错误 line: =====",line)
                this.msg("当前行解析有勿："+line);
                return
            }
            // 去除键和值两边的空白字符
            const trimmedKey = key.trim();
            const trimmedValue = value.trim();

            // 检查计数器中是否已经有这个键
            if (keyCount.hasOwnProperty(trimmedKey)) {
                // 键已存在，增加计数
                keyCount[trimmedKey]++;
                // 生成新的键名，包括原键名和它的计数
                const newKey = `${trimmedKey}${keyCount[trimmedKey]}`;
                dataObject[newKey] = trimmedValue;
            } else {
                // 如果计数器中没有这个键，直接添加并初始化计数
                dataObject[trimmedKey] = trimmedValue;
                keyCount[trimmedKey] = 1;
            }
        });

        return dataObject;
    },// 获取字符串中的 数字
    extractNumber(inputString) {
        // 使用正则表达式匹配数字，包括小数点
        const result = inputString.match(/[\d\.]+/);
        if (result) {
            // 如果有匹配，返回第一个匹配的结果
            return result[0];
        }
        return null; // 如果没有数字，返回null
    },
    // 获取字符串中的文字
    extractText(inputString) {
        // 使用正则表达式替换掉所有数字和多余的空格
        const text = inputString.replace(/[\d\.\s]+/g, '').trim();
        return text;
    },
    // 将html 字符串 处理得到文本 只展示 一部分
    extractAndTrimText(htmlString,index) {
        // 创建一个新的DOM元素来存放HTML字符串
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        // 提取纯文本内容
        const textContent = tempDiv.textContent || tempDiv.innerText || "";

        // 检查内容长度并返回相应的字符串
        if (textContent.length > index) {
            return textContent.substring(0, index) + '...';
        } else {
            return textContent;
        }
    },
    removeHtmlAndLimitText(html, maxLength) {
        // 创建一个新的 DOM 元素
        var tempDiv = document.createElement('div');
        // 设置元素的 innerHTML 为传入的 HTML 字符串
        tempDiv.innerHTML = html;
        // 使用 textContent 属性获取纯文本
        var textContent = tempDiv.textContent || tempDiv.innerText || "";
        // 截取字符串确保不超过最大长度
        if (textContent.length<maxLength){
            return textContent;
        } else {
            return textContent.substring(0, maxLength) +"...";
        }
    },
    // 检测是否有权限
    checkPermission(per){
        let role = localStorage.getItem("logistics-permissions");
        return JSON.parse(role).role === "admin";
    },
    createCustomHtml(data) {
        if (typeof data != 'string'){
            return ;
        }
        let resultData = data.split('_');
        // 创建最外层的 <span>
        let outerSpan = document.createElement('span');

        // 创建第一个内部 <span> 并设置内容
        let firstSpan = document.createElement('span');
        firstSpan.innerHTML = resultData[0];

        // 创建文本节点 " 改为 "
        let textNode = document.createTextNode(' 改为 ');

        // 创建第二个内部 <span> 并设置内容
        let secondSpan = document.createElement('span');
        secondSpan.innerHTML = resultData[1];;

        // 将元素添加到最外层 <span>
        outerSpan.appendChild(firstSpan);
        outerSpan.appendChild(textNode);
        outerSpan.appendChild(secondSpan);

        // 返回 HTML 字符串
        return outerSpan.outerHTML;
    },
    createRowHtml(data) {
        if (typeof data != 'string'){
            return ;
        }
        let resultData = data.split(',');
        // 创建最外层的 <span>
        let outerDiv = document.createElement('div');

        resultData.forEach(item=>{
            let itemDiv = document.createElement('div');
            itemDiv.innerHTML = item;
            outerDiv.appendChild(itemDiv);
        })




        // 返回 HTML 字符串
        return outerDiv.outerHTML;
    },
    dealPictureRelativeUrl(url){ // 截取图片 后半部分
        let index = url.indexOf(".com/");
        if (index == -1){
            return url;
        }
        let endIndex = url.indexOf("?Expires");
        if (index === -1){
            return url
        }
        return url.substring(index+5,endIndex);
    },
    // 去除完整图片 url 中无关的部分
    extractFilenames(urlString) {
        // 使用正则表达式匹配 'company/idCard/' 及其后的所有内容，直到遇到 '?' 为止
        const pattern = /company\/([^\/]+)\/[^\?]+/g;
        let match;
        let result = [];

        // 循环匹配所有符合条件的路径部分
        while ((match = pattern.exec(urlString)) !== null) {
            result.push(match[1]); // 将匹配到的路径添加到结果数组中
        }

    // 使用 '_' 连接数组中的所有文件名，并返回结果
    return result.join('_');
    },
    // 截取字符串中文件存放路径 company/employees/20240831195009728.png_company/employees/20240831195017838.png
    extractAndFormatUrls(urlString) {
        // 正则表达式匹配所需的路径部分
        const regex = /company\/[^\/]+\/[^?_]+/g;

        // 使用正则表达式找到所有匹配项
        const matches = urlString.match(regex);

        if (matches) {
            // 将所有找到的匹配项用 "_" 连接起来
            return matches.join('_');
        }

        return ''; // 如果没有找到匹配项，返回空字符串
    },
    dealImgStrToArr(imgStr){ // 解决返回两个或多个图片链接 用 - 链接，组装成数组
        if (imgStr == null || imgStr == ''){
            return [];
        }else {
            return imgStr.split("_")
        }

    },
    tableRowClassName({row, rowIndex}) {
        if (rowIndex%2 ===0) {
            return 'success-row';
        }
        return '';
    },
    showStatus(val){
        if (val == 1){
            return "未确认"
        } else if (val ==2){
            return "已确认"
        } else {
            return "--"
        }
    },
    showExceptionKind(val){
        if (val == 0){
            return "应付异常"
        }  else {
            return "应收异常"
        }
    },
    showExceptionType(kind,type){
        if (kind == 0){
            let result =  this.showPayReviewType(type)
            return result;
        }  else {
            let result =  this.showReviewReviewType(type)
            return result;
        }
    },
    showPayReviewType(val) {
        switch (val) {
            case 1:
                return "空跑补贴";
            case 2:
                return "经停补贴";
            case 3:
                return "压车补贴";
            case 4:
                return "时效扣款";
            case 5:
                return "操作扣款";
            case 6:
                return "方数扣款";
            case 7:
                return "靠台晚点";
            case 8:
                return "技术服务费";
            case 9:
                return "经停扣款";
            case 10:
                return "其他扣款";
            case 11:
                return "其他补贴";
            default:
                return "--";
        }
    },
    showReviewType(val){
        if (val == 1){
            return "首付款"
        } else if (val ==2){
            return "油卡"
        } else if (val ==3){
            return "部分付款"
        } else if (val ==4){
            return "尾款"
        } else if (val ==5){
            return "空跑补贴"
        } else if (val ==6){
            return "批量油卡"
        } else if (val ==7){
            return "批量现金"
        } else {
            return "--"
        }
    },
    showReviewReviewType(val) {
        switch (val) {
            case 1:
                return "货物险";
            case 2:
                return "信息费";
            case 3:
                return "压车放空";
            case 4:
                return "经停补贴";
            case 5:
                return "油补贴";
            case 6:
                return "保险";
            case 7:
                return "时效扣款";
            case 8:
                return "操作扣款";
            case 9:
                return "减经扣款";
            case 10:
                return "其他扣款";
            case 11:
                return "其他补贴";
            default:
                return "--";
        }
    },

    validatePlateNumber(plate) {
        const mainland= /^(?:[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-HJ-NP-Z]{1}(([0-9]{5}[DF]{1}$)|([DF]{1}[A-HJ-NP-Z0-9]{1}[0-9]{4}$))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/;
        if (mainland.test(plate)) {
            return true;
        } else {
            return false;
        }
    },
    validatePhoneNumber(phoneNumber) {
        // 正则表达式检查移动固定电话，覆盖大部分移动运营商的号码段
        const mobilePattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[1-35-9])\d{8}$/;

        // 正则表达式检查固定固定电话，支持带区号或不带区号（默认为某些小地区可能不需要区号的情况）
        const landlinePattern = /^(\d{3,4}-)?\d{7,8}$/;

        if (mobilePattern.test(phoneNumber)) {
            return true;
        } else if (landlinePattern.test(phoneNumber)) {
            return true;
        } else {
            return false;
        }
    },
    generateRandomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },
    dealImgUrl(imageList){ // 将页面对象中的图片，封装成字符串 进行返回
        let voucherUrl="";
        if (imageList.length>0){
            let imgUrlArr = [];
            imageList.forEach(item=>{
                imgUrlArr.push(item.name);
            })
            voucherUrl = imgUrlArr.join("_");
        }
        return voucherUrl;
    },
    dealImgUrlTow(imageList){ // 将页面对象中的图片，封装成字符串 进行返回
        let voucherUrl="";
        if (imageList.length>0){
            let imgUrlArr = [];
            imageList.forEach(item=>{
                imgUrlArr.push(item.imgName);
            })
            voucherUrl = imgUrlArr.join("_");
        }
        return voucherUrl;
    },
    getFormattedDateTime() { // 生成 年月日 - 时分  字符串
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} - ${hours}:${minutes}`;
    },
    // 将 2024-11-03 00:16:21 转成 11月3日
    formatDate(dateString) {
        // 解析日期字符串创建Date对象
        const date = new Date(dateString);

        // 获取月份和日期
        // Date对象中的月份是从0开始的，所以需要+1来获得常规月份数字
        const month = date.getMonth() + 1;
        const day = date.getDate();

        // 返回格式化的字符串
        return `${month}月${day}日`;
    },
    getFormattedDate() { // 2024年10月31日”格式的当前时间
        const date = new Date(); // 获取当前日期和时间

        const year = date.getFullYear(); // 获取年份
        const month = date.getMonth() + 1; // 获取月份，月份索引从0开始，所以加1
        const day = date.getDate(); // 获取日

        // 返回格式化的字符串，确保月和日为两位数字
        return `${year}年${month.toString().padStart(2, '0')}月${day.toString().padStart(2, '0')}日`;
    },
    getFormattedDate1() { // 2024-10-31”格式的当前时间
        const date = new Date(); // 获取当前日期和时间

        const year = date.getFullYear(); // 获取年份
        const month = date.getMonth() + 1; // 获取月份，月份索引从0开始，所以加1
        const day = date.getDate(); // 获取日

        // 返回格式化的字符串，确保月和日为两位数字
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },
    getYear(){
        return new Date().getFullYear();
    },
    collectionCompleted(unclearedTotalReceipts,approvalStatus){
        if (approvalStatus == 6 || unclearedTotalReceipts == 0){
            return "收款完成";
        } else {
            return "收款未完成";
        }
    },
    isNumberOrNumericString(value){
        // 检查是否是数字
        if (typeof value === 'number' && !isNaN(value)) {
            return true;
        }

        // 检查是否是数字的字符串
        if (typeof value === 'string') {
            // 正则表达式来校验是否全为数字（整数或小数）
            return /^-?\d+(\.\d+)?$/.test(value.trim());
        }

        // 如果都不是，则返回false
        return false;
    },
    ensureFullYear(dateStr) {
        // 检查日期格式是否已包含年份（假设年份有四位数字）
        if (/^\d{4}\.\d{1,2}\.\d{1,2}$/.test(dateStr)) {
            // 如果已经包含年份，直接返回原字符串
            return dateStr;
        } else if (/^\d{1,2}\.\d{1,2}$/.test(dateStr)) {
            // 如果不包含年份，补充当前年份
            const currentYear = new Date().getFullYear();
            return `${currentYear}.${dateStr}`;
        } else {
            // 如果格式不匹配，返回错误信息或原始字符串
            console.error("Invalid date format");
            return dateStr; // 或者抛出异常
        }
    },
    getNextYearDateMinusOneDay(inputDateStr) {
        if (inputDateStr == ''){
            return
        }
        // 将输入的日期字符串拆分为 年、月、日
        const [yearStr, monthStr, dayStr] = inputDateStr.split('-');
        const year = parseInt(yearStr, 10);
        const month = parseInt(monthStr, 10) - 1; // JavaScript 的月份从 0 开始
        const day = parseInt(dayStr, 10);
        // 创建输入日期的 Date 对象
        const inputDate = new Date(year, month, day);
        // 校验日期是否有效
        if (isNaN(inputDate.getTime())) {
            throw new Error('无效的日期格式，请使用 "YYYY-MM-DD" 格式');
        }
        // 增加一年
        const nextYearDate = new Date(inputDate);
        nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
        // 减少一天
        nextYearDate.setDate(nextYearDate.getDate() - 1);
        // 格式化结果日期为 "YYYY-MM-DD"
        const resultYear = nextYearDate.getFullYear();
        const resultMonth = String(nextYearDate.getMonth() + 1).padStart(2, '0');
        const resultDay = String(nextYearDate.getDate()).padStart(2, '0');

        return `${resultYear}-${resultMonth}-${resultDay}`;
    },
    formatDateToChinese(dateStr) {
        // 将日期字符串转换为 Date 对象
        // 为了兼容性，建议将 '-' 替换为 '/'
        const date = new Date(dateStr.replace(/-/g, '/'));
        if (isNaN(date.getTime())) {
            throw new Error('无效的日期格式');
        }

        // 获取月份和日期
        const month = date.getMonth() + 1; // 月份从0开始，需要加1
        const day = date.getDate();

        // 格式化为 'MM月DD日'
        return `${month}月${day}日`;
     },
}

export default global;
